__turbopack_context__.v({
  "card": "pJKXYa_card",
  "readMore": "pJKXYa_readMore",
  "titleLink": "pJKXYa_titleLink",
});
